export default __webpack_public_path__ + "static/media/pizza.8ed9a507.jpg";